var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinocular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#009bf2",
    height: "64px",
    width: "64px",
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    stroke: "#009bf2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5,13c1.6,0,3.1,0.5,4.4,1.3l-2.2-7.1C25.1,5.3,23.4,4,21.5,4C19,4,17,6,17,8.5v7.6C18.6,14.2,20.9,13,23.5,13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,13c2.6,0,4.9,1.2,6.5,3.1V8.5C15,6,13,4,10.5,4c-2,0-3.7,1.3-4.3,3.1l-2.2,7.1C5.4,13.5,6.9,13,8.5,13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5,15C4.9,15,2,17.9,2,21.5S4.9,28,8.5,28s6.5-2.9,6.5-6.5S12.1,15,8.5,15z M11.5,21c-0.8,0-1.5-0.7-1.5-1.5 s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S12.3,21,11.5,21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5,15c-3.6,0-6.5,2.9-6.5,6.5s2.9,6.5,6.5,6.5s6.5-2.9,6.5-6.5S27.1,15,23.5,15z M26.5,21c-0.8,0-1.5-0.7-1.5-1.5 s0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5S27.3,21,26.5,21z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinocular);
export default __webpack_public_path__ + "static/media/binocular.43f29b0223f9531a8012f102524f9417.svg";
export { ForwardRef as ReactComponent };